import { render } from "./EdvHeader.vue?vue&type=template&id=5b336851"
import script from "./EdvHeader.vue?vue&type=script&lang=js"
export * from "./EdvHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__